import {timeNotification} from '@/utils/notification-timer';
import {faSquareCheck, faSquareEllipsis, faSquareExclamation, faSquareMinus, faSquarePen} from '@fortawesome/pro-duotone-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Divider, Dropdown, Tooltip} from 'antd';
import {ReactNode, useEffect, useState} from 'react';
import styled from 'styled-components';
import {faCircleCheck} from '@fortawesome/pro-duotone-svg-icons';
import {observer} from 'mobx-react';
import {useStore} from '@/store/root-store';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons';

interface Props {
  articleUuid?: string;
  articleStatus?: string;
  uuidList?: any;
  customLabel?: ReactNode | string;
  isMinified?: boolean;
}

export const ScaArticleStatusSelectorV2 = observer(({articleUuid, articleStatus, uuidList, customLabel, isMinified}: Props) => {
  const {contentOptimizer: {pages: {bulkUpdateData}}} = useStore('');
  const {contentOptimizer: {currentPage: {updateArticleStatusV2}}} = useStore('');

  const statusesSetup = {
    'NOT_BEGUN': {
      apiKey: 'not-begun',
      label: 'Not begun',
      icon: faSquareMinus,
      iconColor: '#F44343',
    },
    'IN_PROGRESS': {
      apiKey: 'in-progress',
      label: 'In Progress',
      icon: faSquarePen,
      iconColor: '#34AEF3',
    },
    'NEEDS_REVIEW': {
      apiKey: 'needs-review',
      label: 'Needs review',
      icon: faSquareExclamation,
      iconColor: '#F1AA3E',
    },
    'COMPLETED': {
      apiKey: 'completed',
      label: 'Complete',
      icon: faSquareCheck,
      iconColor: '#1FAC47',
    },
    'ARCHIVED': {
      apiKey: 'archived',
      label: 'Archive',
      icon: faSquareEllipsis,
      iconColor: '#A3A4A4',
    },
  };

  const [selectedStatus, setSelectedStatus] = useState(articleStatus ?? 'NOT_BEGUN');

  useEffect(() => {
    if (articleStatus) setSelectedStatus(articleStatus);
  }, [articleStatus]);
  const [dropdownVisible, setDropdownVisible] = useState<boolean>(false);

  const updateArticleStatusHandler = async (status, prevStatus, timer?: any) => {
    try {
      await updateArticleStatusV2(status, articleUuid);
    } catch (e) {
      setSelectedStatus(prevStatus);
      clearTimeout(timer);
    }
  };


  const statusChangeHandler = async (status: string) => {
    const prevStatus = selectedStatus;
    setDropdownVisible(false);
    setSelectedStatus(status);
    const timer = setTimeout(() => {
      if (uuidList) {
        bulkUpdateData(uuidList, '', status);
      } else if (selectedStatus) {
        updateArticleStatusHandler(status, prevStatus, timer);
      } else {
        return;
      }
    }, 5000);


    timeNotification('#1FAC47', faCircleCheck, 5, `${uuidList?.length || ''} ${uuidList?.length > 1 ? 'articles' : 'article'} changed status to ${statusesSetup[status].label}`, ()=>{
      clearTimeout(timer);
      setSelectedStatus(prevStatus);
    });
  };


  const menuRender = () => {
    return <>
      {Object.keys(statusesSetup).map((item, idx) => {
        return <>
          <SingleStatusOption key={idx} onClick={() => statusChangeHandler(item)}>
            <FontAwesomeIcon icon={statusesSetup[item].icon} color={statusesSetup[item].iconColor} fontSize={18}/>
            <SingleStatusLabel>{statusesSetup[item].label}</SingleStatusLabel>
          </SingleStatusOption>
          {idx < Object.keys(statusesSetup).length-1 ? <Divider style={{marginTop: 0, marginBottom: 0}}/> : null}
        </>;
      })}

      {/* Template for new item with dropdown */}
      {/* <Popover content={<div>aaaaaaasdasd</div>} placement={'right'}>
    <div style={{width: '100%'}}>
      asdasd
      </div>
    </Popover> */}
    </>;
  };


  return <Wrapper>
    <Dropdown
      visible={dropdownVisible}
      overlay={
        <> <Menu> {menuRender()} </Menu></>
      }
      trigger={['click']}
      placement='bottomLeft'>
      {!customLabel ? <Tooltip title={statusesSetup[selectedStatus]?.label}>
        { isMinified ? <CurrentStatusMini onClick={() => setDropdownVisible(!dropdownVisible)}>
          <FontAwesomeIcon icon={statusesSetup[selectedStatus]?.icon} color={statusesSetup[selectedStatus]?.iconColor} fontSize={18} />
          <FontAwesomeIcon icon={faCaretDown} color={'#4E5156'} style={{marginLeft: 5}} fontSize={12}/>
        </CurrentStatusMini> : <CurrentStatus color={statusesSetup[selectedStatus]?.iconColor} onClick={() => setDropdownVisible(!dropdownVisible)}>
          <FontAwesomeIcon icon={statusesSetup[selectedStatus]?.icon} color={statusesSetup[selectedStatus]?.iconColor} fontSize={18} />
          <CurrentStatusLabel>{statusesSetup[selectedStatus]?.label}</CurrentStatusLabel>
        </CurrentStatus> }
      </Tooltip> : <span onClick={() => setDropdownVisible(!dropdownVisible)}>{customLabel}</span>}
    </Dropdown>
  </Wrapper>;
});

const Wrapper = styled.div`

`;
const CurrentStatus = styled.div<{color?: string}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: ${p => `${p.color}12`};
  padding: 4px 12px;
  border-radius: 6px;
  width: fit-content;
`;
const CurrentStatusLabel = styled.div`
  margin-left: 5px;
`;
const CurrentStatusMini = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const Menu = styled.div`
  background-color: white;
  z-index: 1;
  border-radius: 5px;
  box-shadow:  0px 3px 8px rgba(0, 0, 0, 0.25);
`;
const SingleStatusOption = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 8px; 
`;
const SingleStatusLabel = styled.div`
  color: #121212;
  margin-left: 8px;
`;
